import { z, ZodError } from "zod";

const envSchema = z.object({
  VITE_WEB_BASE_URL: z.url(),
  VITE_API_BASE_URL: z.url(),

  VITE_NODE_ENV: z.enum(["development", "production"]),
  VITE_APP_ENV: z.enum(["development", "staging", "production"]),

  VITE_SENTRY_DSN: z.string().min(1),
});

let validatedEnv;
try {
  validatedEnv = envSchema.parse(import.meta.env);
} catch (error) {
  console.error("Environment variables validation failed, please check your .env file:");
  if (error instanceof ZodError) {
    console.error("Validation errors:", z.treeifyError(error));
  } else {
    console.error("Unexpected error:", error);
  }
  throw new Error("Invalid environment variables");
}

export const env = {
    ...validatedEnv,
    get isProd(): boolean {
        return this.VITE_APP_ENV === "production";
    },
    get isStaging(): boolean {
        return this.VITE_APP_ENV === "staging";
    },
    get isDev(): boolean {
        return this.VITE_APP_ENV === "development";
    },
    get isNotDev(): boolean {
        return !this.isDev;
    },
    get isNotProd(): boolean {
        return !this.isProd;
    },
};
